<template>
    <span>
        <request-customer-anonymization-button
            v-if="! anonymizationRequest"
            :customer="customer"
            :size="size"
            :disabled="disabled"
            :disabled-reason="disabledReason"
            @requested="requestCreated"
        />

        <delete-anonymization-request-button
            v-if="anonymizationRequest"
            :anonymization-request="anonymizationRequest"
            :size="size"
            @deleted="requestDeleted"
        >
            Avbryt anonymisering
        </delete-anonymization-request-button>
    </span>
</template>
<script>
    import DeleteAnonymizationRequestButton from './DeleteAnonymizationRequestButton';
    import RequestCustomerAnonymizationButton from './RequestCustomerAnonymizationButton';

    export default {
        components: {
            DeleteAnonymizationRequestButton,
            RequestCustomerAnonymizationButton,
        },
        props: {
            customer: {
                type: Object,
                required: true,
            },
            size: {
                type: String,
                default: null,
            },
            disabled: {
                type: Boolean,
                required: false,
                default: null,
            },
            disabledReason: {
                type: String,
                default: null,
            },
        },

        data() {
            return {
                anonymizationRequest: this.customer.anonymization_request,
            };
        },

        methods: {
            requestCreated(anonymizationRequest) {
                this.anonymizationRequest = anonymizationRequest;
                this.$emit('updated');
            },

            requestDeleted() {
                this.anonymizationRequest = null;
                this.$emit('updated');
            },
        },
    };
</script>
